var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pension-form',{attrs:{"pension":_vm.pension,"loading":_vm.loading,"disabled":_vm.disabled},on:{"update-pension":(pension) => (pension = pension)}})
}
var staticRenderFns = []

export { render, staticRenderFns }